import { DateTime, Duration } from 'luxon'

import { Data } from '../../../../domain'
import { required } from '../helpers'
import { ValidationFunctions } from '../types'

export const yearMonth: ValidationFunctions = {
  _self: {
    required,
    minYear: (minYear: number) => (value: string) =>
      DateTime.fromISO(value).year >= minYear,
  },
  date: {
    afterOrEqual:
      (option: string, formKey: string) => (value: string, formValues: Data) =>
        DateTime.fromISO(formValues[formKey]) >=
        DateTime.fromISO(value).plus(Duration.fromISO(option)),
    beforeOrEqual:
      (option: string, formKey: string) => (value: string, formValues: Data) =>
        DateTime.fromISO(formValues[formKey]) <=
        DateTime.fromISO(value).plus(Duration.fromISO(option)),
  },
  yearMonth: {
    afterOrEqual:
      (option: string, formKey: string) => (value: string, formValues: Data) =>
        DateTime.fromISO(formValues[formKey]) >=
        DateTime.fromISO(value).plus(Duration.fromISO(option)),
    beforeOrEqual:
      (option: string, formKey: string) => (value: string, formValues: Data) =>
        DateTime.fromISO(formValues[formKey]) <=
        DateTime.fromISO(value).plus(Duration.fromISO(option)),
  },
  vehicleTabs: {
    beforeOrEqual:
      (option: string, formKey: string) => (value: string, formValues: Data) =>
        formValues[formKey]?.specification?.year <=
        DateTime.fromISO(value).plus(Duration.fromISO(option)).year,
  },
}
